<script setup>
import { OhVueIcon } from 'oh-vue-icons';
import { Button } from 'flowbite-vue';

import { storeToRefs } from 'pinia';
import { useApiResponsesStore } from '@/store/responses';
import { useChooserFormStore } from '@/store/forms/chooser';
import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';

const formStore = useChooserFormStore();
const { formData } = storeToRefs(formStore);

const apiResponsesStore = useApiResponsesStore();
const { regionResponses } = storeToRefs(apiResponsesStore);

function set(region) {
    formStore.$patch((state) => {
        state.formData.region.name = region.name;
        state.formData.region.code = region.code;
    });
}

function clear() {
    formStore.$patch((state) => {
        state.formData.region.name = null;
        state.formData.region.code = null;
    });
}
</script>

<template>
    <template v-if="regionResponses.regions">
        <h2 class="my-4 text-lg">
            <TranslationValue id="page1_dropdown_region" />
        </h2>

        <div class="inline-flex gap-2 flex-wrap items-center">
            <template v-if="formData.region.code">
                <Button color="default" @click="clear()">
                    {{ formData.region.name }}
                    <template #suffix>
                        <OhVueIcon name="hi-x" />
                    </template>
                </Button>
            </template>
            <template v-else>
                <Button
                    v-for="(item, index) in regionResponses.regions"
                    :key="index"
                    color="default"
                    :outline="true"
                    @click="set(item)"
                >
                    {{ item.name }}
                </Button>
            </template>
        </div>
    </template>
</template>

<style scoped></style>
